import { Button } from "@synthesis/shared-ui";
import { useState } from "react";
import IconRefresh from "@synthesis/shared-icons/IconRefresh";
import { cn } from "@synthesis/shared-utils";
import { observer } from "mobx-react-lite";
import { usePageStore } from "../applications-page.lib";

const MIN_SPIN_DURATION_MS = 500;

type UpdateListButtonProps = {
  className?: string;
};

export const UpdateListButton = observer(({ className }: UpdateListButtonProps) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const pageStore = usePageStore();

  const handleUpdateList = async () => {
    if (isUpdating) {
      return;
    }

    setIsUpdating(true);
    const startedAt = Date.now();

    try {
      pageStore?.tableApi?.refreshInfiniteCache();
      pageStore?.tableApi?.deselectAll();
    } finally {
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(MIN_SPIN_DURATION_MS - elapsed, 0);

      if (remaining > 0) {
        await new Promise((resolve) => setTimeout(resolve, remaining));
      }

      setIsUpdating(false);
    }
  };

  return (
    <Button
      className={className}
      leftIcon={<IconRefresh className={cn("text-type-minor size-5", isUpdating && "animate-spin")} />}
      theme="secondary"
      size="sm"
      onClick={handleUpdateList}
      disabled={isUpdating}
    />
  );
});
